$(document).ready(function(){
    var scrollAnimations = [];
    var scrollup = $('.tmp_topwrap_v1_fixed');
    scrollAnimations.push({
        'callback': function(scrollTop, scrollBottom, scrollDirection) {
            if (scrollTop > 200) {
                scrollup.addClass("tmp_topwrap_v1_fixed_scrolled");
            }
            else  {
                scrollup.removeClass("tmp_topwrap_v1_fixed_scrolled");
            }
        }
    });
    
    var scrollDirection = 0;
    var i = 0;
    $(window).on('scroll', function(event) {
        var scrollTop = $(this).scrollTop();
        var scrollBottom = $(this).height() + scrollTop;
        for (i = 0; i < scrollAnimations.length; i++) {
            var c = scrollAnimations[i];
            if (c.start && scrollTop < c.start)
                continue;
            if (c.end && scrollTop > c.end)
                continue;
            if (c.condition && !c.condition(scrollTop, scrollBottom, scrollDirection))
                continue;
            c.callback(scrollTop, scrollBottom, scrollDirection);
        }
    });
    
});